export const AVAILABLE_SECTION_PAGES = ["main", "lobby", "leftbar", "game"];

export const PAGE_LABELS = { main: "Home", lobby: "Lobby", leftbar: "Sidebar", game: "Game Page" };
export const PAGE_COLORS = { main: "#0972d3", lobby: "#037f0c", game: "#d91515", leftbar: "#5f6b7a" };

export const PAGE_OPTIONS = [
	{ label: "Home", value: "main" },
	{ label: "Lobby", value: "lobby" },
	{ label: "Game Page", value: "game" },
	{ label: "Sidebar", value: "leftbar" },
];

export const AUDIENCE_OPTIONS = [
	{ label: "Logged In", value: "authorized" },
	{ label: "Guest", value: "unauthorized" },
];

export const DEFAULT_ORDER_CONTEXT_OPTIONS = [
	{ label: "main / authorized", value: "main_authorized" },
	{ label: "main / unauthorized", value: "main_unauthorized" },
	{ label: "lobby / authorized", value: "lobby_authorized" },
	{ label: "lobby / unauthorized", value: "lobby_unauthorized" },
	{ label: "game / authorized", value: "game_authorized" },
	{ label: "game / unauthorized", value: "game_unauthorized" },
	{ label: "leftbar / authorized", value: "leftbar_authorized" },
	{ label: "leftbar / unauthorized", value: "leftbar_unauthorized" },
];

export const normalizeSectionPageAlias = (value) => {
	const normalizedValue = String(value || "").trim().toLowerCase();
	if (normalizedValue === "landing") return "main";
	if (normalizedValue === "sidebar") return "leftbar";
	if (normalizedValue === "gamepage") return "game";
	return normalizedValue;
};

export const normalizeSectionPageList = (value) => {
	if (Array.isArray(value)) return value.map(normalizeSectionPageAlias).filter(Boolean);
	if (typeof value === "string") {
		try {
			const parsed = JSON.parse(value);
			if (Array.isArray(parsed)) return parsed.map(normalizeSectionPageAlias).filter(Boolean);
			if (parsed !== null && typeof parsed !== "object") return [normalizeSectionPageAlias(parsed)].filter(Boolean);
		} catch (error) {
			return value.split(",").map(normalizeSectionPageAlias).filter(Boolean);
		}
	}
	if (value !== undefined && value !== null) return [normalizeSectionPageAlias(value)].filter(Boolean);
	return [];
};

export const normalizeStatusOption = (statusValue) => {
	const value = String(statusValue || "").trim().toLowerCase() === "active" ? "active" : "inactive";
	return { label: value === "active" ? "Active" : "Inactive", value };
};

export const isGameSectionActive = (item) => String(item?.status || "").trim().toLowerCase() === "active";

export const getPriorityKeysForPage = (page) => [page, `${page}_authorized`, `${page}_unauthorized`];

const SECTION_SLUG_PATTERN = /^[a-z][a-z0-9-]*$/;

export const normalizeSectionSlug = (value) =>
	String(value || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export const validateSectionSlug = (value) => {
	const slug = normalizeSectionSlug(value);
	const reserved = new Set(["recent", "favorite", "providers"]);
	if (!slug) return { error: "Section slug is required." };
	if (!SECTION_SLUG_PATTERN.test(slug)) return { error: "Use english letters, numbers and hyphen. Must start with a letter." };
	if (/^\d+$/.test(slug)) return { error: "Slug must not be numeric only." };
	if (slug.startsWith("section-")) return { error: "Slug must not start with section-." };
	if (reserved.has(slug)) return { error: "This slug conflicts with built-in routes." };
	return { slug, valid: true };
};

export const createEmptyOrderBuckets = (options = DEFAULT_ORDER_CONTEXT_OPTIONS) => options.reduce((accumulator, option) => {
	accumulator[option.value] = [];
	return accumulator;
}, {});

export const mapOrderContextOptions = (options) => Array.isArray(options) && options.length
	? options.map((item) => ({ label: item.label || item.key || item.value, value: item.key || item.value }))
	: DEFAULT_ORDER_CONTEXT_OPTIONS;

export const normalizePriorityBySelectedPages = (pages = [], priorityByPage = {}) => {
	const allowedKeys = new Set((pages || []).flatMap(getPriorityKeysForPage));
	const safePriority = Object.keys(priorityByPage || {}).reduce((accumulator, key) => {
		if (allowedKeys.has(key)) accumulator[key] = priorityByPage[key];
		return accumulator;
	}, {});
	(pages || []).forEach((page) => {
		if (typeof safePriority[page] === "undefined") safePriority[page] = 0;
	});
	return safePriority;
};

export const createGameSectionFormData = (item = {}, overrides = {}) => ({
	date: item.date || new Date(),
	icon: item.icon || "",
	id: item.id || 0,
	name: item.name || "",
	page: normalizeSectionPageList(item.page),
	priority_by_page: item.priority_by_page && typeof item.priority_by_page === "object" ? item.priority_by_page : {},
	status: item.status?.value ? item.status : normalizeStatusOption(item.status || "active"),
	...overrides,
});
